import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MUIButton from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'


import Loading from './Loading'

const styles = {}


const Button = ({
  classes,
  children,
  disabled,
  isLoading,
  className,
  ...props
}) => {
  return (
    <MUIButton
      {...props}
      className={classNames(classes.root, className)}
      disabled={disabled || isLoading}
    >
      {isLoading && <Loading size={16} className="mr1" />}
      {children}
    </MUIButton>
  )
}


Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Button)
